import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { io } from "socket.io-client"; // Certifique-se de ter instalado: npm install socket.io-client
import { useSettings } from "../contexts/SettingsContext";
import { useAuth } from "../contexts/AuthContext";

// ✅ Instância única fora do componente evita abrir múltiplas conexões
const socket = io("https://imagensdaface.com.br", {
  transports: ["websocket", "polling"],
  autoConnect: true
});

export default function MainLayout({ children }) {
  const { settings, loading } = useSettings();
  const { user } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // Função para enviar os dados
    const track = () => {
      if (socket.connected) {
        socket.emit("track_view", {
          userId: user?.id || "Visitante",
          userName: user?.name || "Anônimo",
          page: location.pathname,
          timestamp: new Date()
        });
      }
    };

    track(); // Tenta enviar na mudança de rota
    
    socket.on("connect", track); // Garante envio se a conexão demorar a subir
    return () => socket.off("connect", track);
  }, [location.pathname, user]);

  const bgColor = settings?.SITE_BACKGROUND_COLOR || "#f8fafc";
  if (loading) return null;

  return (
    <div
      id="main-app-layout"
      className="min-h-screen transition-colors duration-700 w-full"
      style={{
        backgroundColor: bgColor,
        "--site-db-bg": bgColor, 
      }}
    >
      {children}
    </div>
  );
}